import cx from 'classnames'
import Styles from './UploadsRow.module.scss'

import { Heading } from 'blaze-ui/Heading/Heading'
import { Carousel } from 'components/Carousel/Carousel'

import { useUploads } from 'components/Design/UploadsTab/useUploads'
import { collectResults } from 'utils/query'
import { Button } from 'blaze-ui/Button'
import { useImageMenuContext } from '../ImageMenuContext'
import { SelectableFile } from '../SelectableFile/SelectableFile'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { getAcceptedFiles } from 'components/ImageMenu/utils'

const UploadsRowContent = () => {
  const { setProvider, selectedImages, toggleSelectedImage, accept } = useImageMenuContext()
  const uploadsQuery = useUploads()
  const uploadFiles = collectResults(uploadsQuery, (data) => data.files)
  const uploads = getAcceptedFiles(uploadFiles, accept)

  if (uploads.length === 0) return null

  return (
    <div className={cx(Styles.row, Styles.uploadsRow, Styles.container)}>
      <div className={Styles.rowHeader}>
        <Heading level={4} color="var(--dark-80)">
          Uploads
        </Heading>
        <Button size="sm" variant="ghost" onPress={() => setProvider('uploads')}>
          See All
        </Button>
      </div>
      <Carousel offset={20}>
        {uploads.map((upload) => (
          <SelectableFile
            key={upload.source_url}
            onSelect={() =>
              upload.source_url && toggleSelectedImage({ ...upload, url: upload.source_url, provider: 'uploads' })
            }
            isSelected={selectedImages.some((i) => i.url === upload.source_url)}
          >
            <img data-testid={`upload-${upload.id}`} src={upload.thumbnail_url || upload.source_url} alt="" />
            {upload.duration && <VideoDuration duration={upload.duration} />}
          </SelectableFile>
        ))}
      </Carousel>
    </div>
  )
}

export const UploadsRow = () => {
  const { hiddenProviders } = useImageMenuContext()

  if (hiddenProviders.includes('uploads')) return null

  return <UploadsRowContent />
}
